import { Color } from '../../../constants';

export type RealtimeEvent = {
  timestamp: string;
  name: string | null;
  user_id: string;
  context_app_name: string;
};

export const chartTheme = {
  axis: {
    style: {
      axis: {
        stroke: 'none',
      },
      grid: {
        stroke: 'none',
      },
      tickLabels: {
        fill: '#7171a6',
        fontFamily: 'Inter, sans-serif',
        padding: 10,
        stroke: 'transparent',
      },
    },
  },
  bar: {
    style: {
      data: {
        fill: Color.primaryVibrant,
      },
    },
  },
} as const;
